import React from 'react';
import { MessageCircle } from 'lucide-react';
import { contactInfo } from '../mock';

const WhatsAppButton = () => (
  <a
    href={contactInfo.whatsapp}
    target="_blank"
    rel="noreferrer"
    aria-label="WhatsApp"
    className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-14 h-14 rounded-full shadow-lg transition-transform hover:scale-110"
    style={{ background: '#25D366' }}
  >
    <MessageCircle size={28} className="text-white" fill="white" strokeWidth={0} />
    <MessageCircle size={26} className="absolute text-[#25D366]" />
  </a>
);

export default WhatsAppButton;
